import './Text.css';

export function DocumentaryAndEducation() {
  return (
    <div class="body">

<div class="row" id="GalleryThree">

 <div class="column">

                  <a href="/FreedomSchool">
               <img alt="Freedom School" src="FreedomSchool03.jpg"></img>
            </a>

            <br/>
            <h4><a href="/FreedomSchool">Freedom School</a>
                , 2025
                <br/>James and Grace Lee Boggs Foundation<br/> Detroit, MI</h4>

      </div>      </div>

        <div class="row" id="GalleryThree">

                  <div class="column">

                  <a href="/Preach">
               <img alt="How Can You Love Someone Who Wants You Dead?" src="Preach.gif"></img>
            </a>


            <h4><a href="/Preach">How Can You Love Someone Who Wants You Dead?</a>
                , 2025
                <br/> Open mic with worksheets </h4>

  </div>


                  <div class="column">

                  <a href="/AHole">
               <img alt="A-Hole Documentary" src="AHolePreview.gif"></img>
            </a>


            <h4>
              <a href="/AHole">A-Hole Documentary</a>
                , 2023
                <br/> 
               <b>Client:</b>  A-Hole</h4>

  </div>




    </div>
    </div>


  );
}
